/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <h1 class="ion-text-center">Maintenance</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container" >

      <div class="d-flex flex-col align-center">
        <br>
        <ion-icon style="font-size: 100px;" color="primary" name="cog"></ion-icon>
        <br>
        <ion-text color="primary" class="text-center">Le service {{ name }} est en <b>cours de maintenance</b> pour vous offrir la toute dernière version, avec un design épuré, des nouvelles fonctionnalités pour covoiturer en toute simplicité et en toute sécurité.</ion-text>
        <br>
        <ion-button @click="goToHome()" color="primary" expand="block">Rééssayer</ion-button>
      </div>
      </div>
    </ion-content>
  </div>
</template>

<style lang="scss">

</style>

<script>

  export default {
    name: 'error',
    data () {
      return {
        name: process.env.VUE_APP_NAME
      }
    },
    props : [],
    created() {

    },
    methods: {
      goToHome() {
        window.location.href = '/';
      }
    }
  }
</script>
